import { session } from '@/shared/utils/storage';

export const currentPage = (): string | null => session.get('currentPage') || null;
